package com.royceecoleman.bill.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page

@Page
@Composable
fun homePage() {
    BillingWorkbenchPage()
}
